var React = require('react');

function OperationDate (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.375 22.4943H5.625V10.1744H21.375M18 2.33435V4.57435H9V2.33435H6.75V4.57435H5.625C4.37625 4.57435 3.375 5.57115 3.375 6.81435V22.4943C3.375 23.0885 3.61205 23.6582 4.03401 24.0782C4.45597 24.4983 5.02827 24.7343 5.625 24.7343H21.375C21.9717 24.7343 22.544 24.4983 22.966 24.0782C23.388 23.6582 23.625 23.0885 23.625 22.4943V6.81435C23.625 5.57115 22.6125 4.57435 21.375 4.57435H20.25V2.33435M19.125 14.6543H13.5V20.2543H19.125V14.6543Z","fill":"#FECD12"}));
}

OperationDate.defaultProps = {"width":"27","height":"29","viewBox":"0 0 27 29","fill":"none"};

module.exports = OperationDate;

OperationDate.default = OperationDate;
